import React, { useState } from 'react';
import { PlusIcon } from '@radix-ui/react-icons';
import { Button, Card, CardContent, PageHeader } from '../components/ui';
import { BugReportModal, SupportTicketList } from '../components/features/support';

/**
 * Support - your tickets, and one line on how to reach us.
 *
 * The page opened with three static cards ("Email Support", "Response Time",
 * "Priority Support") that consumed the entire fold to say almost nothing: two
 * of them were policy boilerplate with no action attached. A manager landing
 * here has a problem right now and wants to see their open tickets or raise a
 * new one. The contact route is preserved as a single line; the tickets get
 * the page.
 */
export default function Support() {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<div className="min-h-screen bg-muted">
			<div className="max-w-7xl mx-auto p-4 sm:p-6">
				<PageHeader
					title="Support"
					description="Track your tickets, or raise a new one - we prioritise by severity."
					actions={
						<Button onClick={() => setIsModalOpen(true)} className="flex items-center gap-2">
							<PlusIcon className="w-4 h-4" />
							New ticket
						</Button>
					}
				/>

				<Card>
					<CardContent className="p-4 sm:p-6">
						<SupportTicketList />
					</CardContent>
				</Card>

				<p className="mt-4 text-sm text-muted-foreground">
					Urgent and can't wait?{' '}
					<a
						href="mailto:support@getrepcheck.com"
						className="font-medium text-brand-600 hover:text-brand-700"
					>
						support@getrepcheck.com
					</a>
				</p>
			</div>

			<BugReportModal open={isModalOpen} onOpenChange={setIsModalOpen} />
		</div>
	);
}
